var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuIcon",attrs:{"id":"menuIcon"}},[_c('div',{staticClass:"menuIconContainer",class:{ open: _vm.isOpen },attrs:{"id":"menuIconContainer"},on:{"click":function($event){return _vm.emitIconState()}}},[_c('div',{staticClass:"menuIconBar1"}),_c('div',{staticClass:"menuIconBar2"}),_c('div',{staticClass:"menuIconBar3"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }